module.exports = __webpack_public_path__ + "assets/img/6_495_big.f212ec45.jpg";